import React ,{useState} from "react";
import '../styles/LicensePage.css';
import '../styles/LandingPage.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const LicensePage = () => {
    const [isChecked, setIsChecked] = useState(false);

    // Function to handle checkbox change
    const handleCheckboxChange = (e) => {
        setIsChecked(e.target.checked);
    };
    return (
        <>
        <Navbar />
        <main className="main-content">
            <div className="license-page">
                <div className="license-heading"> 
                    <h1>End-User License Agreement of IIITH</h1> 
                </div>
                <div className="license-content">
                        <h4>End-User License Agreement (EULA) of IIITH</h4>
                        <p>
                            This End-User License Agreement (“EULA”) is a legal agreement between you and IIITH. This EULA agreement governs your acquisition and use of our IIITH software (“Software”) directly from IIITH or indirectly through an IIITH authorized reseller or distributor (a “Reseller”).
                        </p>
                        
                        <p>
                            Please read this EULA agreement carefully before completing the installation process and using the IIITH software. It provides a license to use the IIITH software and contains warranty information and liability disclaimers.
                        </p>

                        <p>
                            If you register for a free trial of the IIITH software, this EULA agreement will also govern that trial. By installing and/or using the IIITH software, you are confirming your acceptance of the Software and agreeing to become bound by the terms of this EULA agreement.
                        </p>

                        <p>
                            If you are entering into this EULA agreement on behalf of a company or other legal entity, you represent that you have the authority to bind such entity and its affiliates to these terms and conditions. If you do not have such authority or if you do not agree with the terms and conditions of this EULA agreement, do not install or use the Software, and you must not accept this EULA agreement.
                        </p>

                        <p>
                            This EULA agreement shall apply only to the Software supplied by IIITH herewith regardless of whether other software is referred to or described herein. The terms also apply to any IIITH updates, supplements, Internet-based services, and support services for the Software, unless other terms accompany those items on delivery. If so, those terms apply.
                        </p>

                        <h4>License Grant</h4>

                        <p>
                            IIITH hereby grants you a personal, non-transferable, non-exclusive license to use the IIITH software on your devices in accordance with the terms of this EULA agreement.
                        </p>

                        <p>
                            You are permitted to load the IIITH software (for example a PC, laptop, mobile, or tablet) under your control. You are responsible for ensuring your device meets the minimum requirements of the IIITH software.
                        </p>

                        <p>
                            You are not permitted to:
                            <ul>
                                <li>Edit, alter, modify, adapt, translate or otherwise change the whole or any part of the Software nor permit the whole or any part of the Software to be combined with or become incorporated in any other software, nor decompile, disassemble or reverse engineer the Software or attempt to do any such things.</li>
                                <li>Reproduce, copy, distribute, resell or otherwise use the Software for any commercial purpose.</li>
                                <li>Allow any third party to use the Software on behalf of or for the benefit of any third party.</li>
                                <li>Use the Software in any way which breaches any applicable local, national, or international law.</li>
                                <li>Use the Software for any purpose that IIITH considers a breach of this EULA agreement.</li>
                            </ul>
                        </p>

                        <h4>Intellectual Property and Ownership</h4>

                        <p>
                            IIITH shall at all times retain ownership of the Software as originally downloaded by you and all subsequent downloads of the Software by you. The Software (and the copyright and other intellectual property rights of whatever nature in the Software, including any modifications made thereto) are and shall remain the property of IIITH.
                        </p>

                        <p>
                            IIITH reserves the right to grant licenses to use the Software to third parties.
                        </p>

                        <h4>Termination</h4>

                        <p>
                            This EULA agreement is effective from the date you first use the Software and shall continue until terminated. You may terminate it at any time upon written notice to IIITH.
                        </p>

                        <p>
                            It will also terminate immediately if you fail to comply with any term of this EULA agreement. Upon such termination, the licenses granted by this EULA agreement will immediately terminate and you agree to stop all access and use of the Software. The provisions that by their nature continue and will survive any termination of this EULA agreement.
                        </p>

                        <h4>Limited Warranty</h4>

                        <p>
                            No Warranties: The Author of this Software expressly disclaims any warranty of the Software. The Software and any related documentation is provided “as is” without warranty of any kind, either expressed or implied, including, without limitation, the implied warranties of merchantability, fitness for a particular purpose, or non-infringement. The entire risk arising out of use or performance of the Software remains with you.
                        </p>

                        <p>
                            No Liability for Damages: In no event shall IIITH be liable for any special, consequential, incidental, or indirect damages whatsoever (including, without limitation, damages for loss of business profits, business interruption, loss of business information, or any other pecuniary loss) arising out of the use of or inability to use the Software, even if IIITH is aware of the possibility of such damages and known defects.
                        </p>

                        <h4>Governing Law</h4>

                        <p>
                            This EULA agreement, and any dispute arising out of or in connection with this EULA agreement, shall be governed by and construed in accordance with the laws of India.
                        </p>
                        <div className="Agree_tc" style={{marginTop:'4vw', fontSize:'1vw', color:'white', display: 'flex', alignItems: 'center'}}>
                        <input 
                            type="checkbox" 
                            id="agree_tc" 
                            style={{ width: '1vw', height: '1vw', marginTop: '0.2vw', cursor:'pointer' }} 
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                        />
                        <label htmlFor="agree_tc" style={{ marginLeft: '0.5vw' }}>I agree to the terms and conditions</label>
                    </div>

                    <div className='getAnavu' style={{ marginTop: '1vw', justifyContent: 'flex-start',cursor: isChecked ? 'pointer' : 'not-allowed' }}>
                        <a 
                            href={isChecked ? "/signUp" : "#"} 
                            onClick={e => !isChecked && e.preventDefault()} 
                            style={{  pointerEvents: isChecked ? 'auto' : 'none'}}
                        >
                            <div className='getAnavu_text'>
                                GET ANAVU
                            </div>
                        </a>
                    </div>

                </div>
                
            </div>
        </main>
        <Footer />
        </>
    );
};

export default LicensePage;
